import { useEffect, useRef } from 'react';

import { emptyArray } from 'Lib/constants/placeholder';
import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';

const useRequestIdleCallback = (callback?: VoidFunction, dep = emptyArray) => {
  const callbackRef = useRef<VoidFunction>();

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (callbackRef.current) {
      requestIdleCallbackManager.addTask(callbackRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dep);
};

export default useRequestIdleCallback;
